







































import userApi from "@/api/userApi";
import qNotify from "@/common/qNotify";
import {Component, Mixins} from "vue-property-decorator";
import UserCompany, {COOPERATION_ACCEPT} from "@/model/userCompany";
import Authority from "@/common/mixins/authority";
import User, {STATUS} from "@/model/user";
import _ from "lodash";
import {namespace} from "vuex-class";
import store from "@/store";
import defineAbilityFor from "@/services/ability";
import Company from "@/model/company";
import moment from "moment/moment";
import { DATE_FORMAT } from "@/common/constant";
const auth = namespace("Auth");

@Component({
  name: "CompanyCooperationAccept",
})
export default class CompanyCooperationAccept extends Mixins(Authority) {
  @auth.Getter
  getUserLogging!: User;
  @auth.Getter
  getCompanyLinked!: Company[]
  @auth.Getter
  getUserCompanies!:UserCompany[]

  public userCompany: UserCompany = new UserCompany();
  public isShow = false;

  async mounted() {
    await this.getDetail();
    if(!this.getUserLogging || !this.userCompany || this.userCompany.user_id != this.getUserLogging.id) {
      store.dispatch("Auth/setDefaultAuth");
      this.$router.push({ name: "not-found" });
      return;
    }

    if(this.userCompany.isManager
        && (!this.userCompany.company.license_is_active && this.userCompany.company.license_is_oldest)
        && (moment(moment().format(DATE_FORMAT)).isBefore(moment(this.userCompany.company.license_is_oldest.applicable_date).format(DATE_FORMAT)))
    ) {
      qNotify.error({
        text: this.$t('companies.license_is_not_active', {
          applicable_date: moment(this.userCompany.company.license_is_oldest.applicable_date).format(DATE_FORMAT)
        }),
      });
      this.$router.push({
        name: "login",
      });
    }

    if(this.userCompany.status == STATUS.WAIT) {
      this.isShow = true;
    } else {
      this.$router.push({
        name: "login",
      });
    }
  }

  get userCompanyId() {
    return this.$router.currentRoute.params.userCompanyId;
  }

  public async getDetail() {
    const result = await userApi.getUserCooperation(this.userCompanyId);

    if (result) {
      this.userCompany = new UserCompany(result.data);
    }
  }

  public accept() {
    this.submit(COOPERATION_ACCEPT.ACCEPT);
  }

  public reject() {
    this.submit(COOPERATION_ACCEPT.REJECT);
  }

  public async submit(type) {
    const result = await userApi.link({
      user_company_id: this.userCompanyId,
      type: type,
    });

    if (result.meta.status === 200) {
      qNotify.success({
        text:
          type === COOPERATION_ACCEPT.REJECT
            ? this.$t("users.cooperation_rejected")
            : this.$t("users.cooperation_accepted"),
      });
      if(type == 1) {
        store.dispatch("Auth/setUsingCompany", this.userCompany.id);
        this.$ability.update(defineAbilityFor(this.$store.state.Auth.userLogging.type, this.userCompany.role_id).rules);
        const companies = _.cloneDeep(this.getCompanyLinked).map(item => {
          if (this.userCompany.company && item.id === this.userCompany.company.id) {
            item.pivot.status = 1;
          }
          return item;
        });
        const userCompanies = _.cloneDeep(this.getUserCompanies).map(item => {
          if (item.id === this.userCompany.id) {
            item.status = 1;
          }
          return item;
        });
        store.dispatch("Auth/setCompanyLinked", companies);
        store.dispatch("Auth/setUserCompanies", userCompanies);
        this.$router.push({
          name: "admin.dashboard",
        });
      } else {
        const companies = this.getCompanyLinked.filter(
          (item) => this.userCompany.company && item.id !== this.userCompany.company.id
        );
        const userCompanies = this.getUserCompanies.filter(
          (item) => item.id !== this.userCompany.id
        );
        store.dispatch("Auth/setCompanyLinked", companies);
        store.dispatch("Auth/setUserCompanies", userCompanies);
        this.$router.push({
          name: "login",
        });
      }
    } else {
      qNotify.error({
        text: result.meta.message,
      });
    }
  }
}
